export enum ClientConsultNoteTaskStatus {
  open = 'open',
  closed = 'closed',
}
